import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Table, Row } from 'components/patterns'
import { Checkbox, TextArea } from 'components/patterns/Inputs'

export const StyledTextArea = styled(TextArea)`
  margin-top: 20px;
  min-width: 250px;
  margin: 0;
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 5px;
`

export const DiffCountTitle = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
  color: ${themeColor('blackPrimary')};
`

export const Count = styled.span`
  font-weight: bold;
`

export const DomainTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${themeColor('blackPrimary')};
`

export const StyledTable = styled(Table)`
  .ant-table-body {
    overflow-x: hidden !important;
  }
  .ant-table-header {
    padding-right: 16px !important;
    background-color: ${themeColor('greySecondary')};
  }
`

export const StyledCheckBox = styled(Checkbox)`
  .pto-diff-row {
    color: ${themeColor('blackSecondary')};
  }
  & .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${themeColor('blueSecondary')};
    border-color: ${themeColor('blueSecondary')};
  }
`

export const PtoDomainElement = styled.div`
  position: relative;
  display: flex;
  padding: 5px;
  margin: 14px 0px;
  width: 100%;
  height: 48px;
  border: 1px solid ${themeColor('greyPrimary')};
  box-sizing: border-box;
  justify-content: space-between;
`

export const PtoDomainElementTitle = styled.div`
  position: relative;
  height: 22px;
  left: 20px;
  top: 8px;

  font-family: Arial;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;

  color: themeColor('black');
`

export const PtoRightSideItemsWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Divider = styled.div`
  width: 1px;
  height: 16px;
  margin: 0 8px;
  background-color: ${themeColor('greyPrimary')};
`

export const PtoOutofRangeWarningContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const WarningIcon = styled.img`
  width: 20px;
  height: 18px;
`

export const OutofRangeWarningText = styled.span`
  font-size: 14px;
  color: ${themeColor('blackSecondary')};
`

export const PtoDomainPopDetails = styled.div`
  font-size: 14px;
  color: ${themeColor('blueSecondary')};

  &:hover {
    cursor: pointer;
  }
`

export const PtoDomainNoFragments = styled.div`
  position: absolute;
  top: 14px;
  right: 10px;
`

export const ChooseDomainTitle = styled.div`
  width: 504px;
  height: 24px;

  font-family: Arial;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;

  color: ${themeColor('blackPrimary')}
  opacity: ${(props) => (props.isFormEnabled ? 1.0 : 0.2)};
`

export const TemplateDetailsEdit = styled.div`
  display: inline-block;
  vertical-align: top;
  height: 50px;
  width: 100%;
`

export const InputRow = styled(Row)`
  padding-bottom: 30px;
`
export const DisabledText = styled.span`
  color: ${themeColor('greyPrimary')};
 wordWrap: break-word;
  wordBreak: 'break-word;
`
